import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { UserService } from '@app/user';

@Component({
    selector: 'app-profile-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ProfileAvatarComponent {
    private readonly userService = inject(UserService);

    @Input({ required: true })
    size!: 'xs' | 'sm' | '2md' | 'md' | 'lg' | 'xl';

    get initials(): string {
        const user = this.userService.user;
        return user ? user.firstname.charAt(0) + user.surname.charAt(0) : '';
    }
}
